<template>
	<v-speed-dial
		v-model="fab"
		:open-on-hover="false"
		:direction="$vuetify.breakpoint.smAndDown ? 'bottom' : 'left'"
		:transition="
			$vuetify.breakpoint.smAndDown
				? 'slide-y-transition'
				: 'slide-x-transition'
		"
		absolute
	>
		<template v-slot:activator>
			<v-btn v-model="fab" icon>
				<v-icon large>
					{{
						$vuetify.breakpoint.smAndDown
							? 'mdi-dots-horizontal'
							: 'mdi-dots-vertical'
					}}
				</v-icon>
			</v-btn>
		</template>
		<v-btn large fab color="orange">
			<v-icon color="white" size="35">mdi-magnify</v-icon>
		</v-btn>
		<v-btn large fab color="indigo">
			<v-icon color="white" size="35">mdi-calendar</v-icon>
		</v-btn>
		<v-btn large fab color="blue">
			<v-icon color="white" size="35">mdi-pencil</v-icon>
		</v-btn>
		<v-btn large color="purple" fab>
			<v-icon color="white" size="35"> mdi-camera </v-icon>
		</v-btn>
		<v-btn large color="deep-purple" dark fab>
			<v-icon size="35">mdi-information-outline</v-icon>
		</v-btn>
	</v-speed-dial>
</template>

<script>
export default {
	name: 'Dial',
	data: () => ({
		fab: false,
	}),
	computed: {},
	methods: {},
};
</script>
